import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./WB.css";
import { FaWhatsapp } from "react-icons/fa"; // Import WhatsApp icon

const WhatsAppButton = () => {
  const phoneNumber = "919879618851"; // Replace with your WhatsApp number
  const message = "Hello! I'm interested in your services."; // Custom message

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
    >
      <FaWhatsapp size={40} />
    </a>
  );
};

export default WhatsAppButton;
